import { Button } from '@crazyegginc/hatch';

import { Modal } from '/src/contexts/modal';
import { WebP } from '/src/components/WebP';
import { UpsellWall } from '/src/components/UpsellWall';
import { AppLink } from '/src/features/_global/components/AppLink';
import { useManageSubscriptionPath } from '/src/hooks';

import SurveysPNG from '@crazyegginc/hatch/dist/images/illustration-survey.png';
import SurveysWebP from '@crazyegginc/hatch/dist/images/illustration-survey.webp';
import { ReactComponent as ArrowIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';

const TEXT_LIST = [
  {
    text: 'Get direct feedback from the people that matter with Surveys.',
  },
  {
    text: 'Customizable designs with in-built accessibility standards.',
  },
  {
    text: 'Learn what your visitors think, instantly.',
  },
];

export function SurveyUpsellModal({ onBack }) {
  const manageSubscriptionPath = useManageSubscriptionPath();

  return (
    <Modal
      dialogClassName="!w-[640px] !px-2"
      dismissable={onBack ? false : true}
      disableOutsideClick={onBack ? true : false}
    >
      <div className="flex items-center">
        <div className="mx-4 flex items-center shrink-0">
          <WebP webp={SurveysWebP} fallback={SurveysPNG} width="190px" height="161px" alt="surveys feature" />
        </div>
        <div>
          <h2 className="text-header-1 font-semibold">Targeted feedback with Surveys</h2>
          <div className="text-body-2 my-6">
            Connect with your customers and website visitors to learn what makes them tick, what they want more of, and
            how they feel about your service.
          </div>
          <UpsellWall.List list={TEXT_LIST} />
          <div className="w-full flex mt-1 space-x-2.5">
            {onBack ? (
              <Button variant="cancel" onClick={onBack}>
                <ArrowIcon className="mr-2 h-2.5 w-2.5 -rotate-90 fill-current" />
                Go Back
              </Button>
            ) : null}
            <Button component={AppLink} to={manageSubscriptionPath} target="_blank" rel="noopener noreferrer">
              View Plans
            </Button>
          </div>
        </div>
      </div>
      {onBack ? (
        <Button variant="cancel" onClick={onBack} className="absolute top-2 left-2">
          <ArrowIcon className="mr-2 h-2.5 w-2.5 -rotate-90 fill-current" />
          Back
        </Button>
      ) : null}
    </Modal>
  );
}
